import moment from 'moment'

// "(עודכן לאחרונה: DD/MM/YYYY HH:mm ע"י <name>)" next to the Company Raw Text label.
// Date only when there is no name; '' when there is no (valid) date — a name
// without a date is not shown on its own.
export const formatRawTextUpdated = (updatedAt, updatedBy) => {
  if (!updatedAt) return ''
  const date = moment(updatedAt)
  if (!date.isValid()) return ''
  const name = typeof updatedBy === 'string' ? updatedBy.trim() : ''
  const by = name ? ` ע"י ${name}` : ''
  return `(עודכן לאחרונה: ${date.format('DD/MM/YYYY HH:mm')}${by})`
}

// Picks the two audit fields out of a save response or a re-fetched position.
// Returns null when the object carries neither key (e.g. the PUT answered 204).
export const pickRawTextAudit = source => {
  if (!source || typeof source !== 'object') return null
  if (!('company_raw_text_updated_at' in source) && !('company_raw_text_updated_by' in source)) return null
  return {
    updated_at: source.company_raw_text_updated_at || null,
    updated_by: source.company_raw_text_updated_by || null
  }
}
